import { render, staticRenderFns } from "./suppliers-performance-orders-chart.vue?vue&type=template&id=3c347d80&scoped=true&"
import script from "./suppliers-performance-orders-chart.vue?vue&type=script&lang=js&"
export * from "./suppliers-performance-orders-chart.vue?vue&type=script&lang=js&"
import style0 from "./suppliers-performance-orders-chart.vue?vue&type=style&index=0&id=3c347d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c347d80",
  null
  
)

export default component.exports